/**
 * Beloved — gentle urgent-support detection.
 *
 * This is intentionally narrow and non-diagnostic. It only recognises direct
 * wording about immediate danger, self-harm, suicide, abuse, or harming someone
 * else. A match never blocks prayer and never sends anything anywhere; it only
 * lets the interface show a calm reminder to seek immediate human help too.
 */

export const URGENT_SUPPORT_MESSAGE =
  'Beloved can pray with you, but it cannot provide urgent help. If you or someone else may be in immediate danger, contact your local emergency services now. If you can, move somewhere safer and tell someone you trust.';

const URGENT_PATTERNS = [
  /\b(?:kill|hurt|harm)\s+myself\b/i,
  /\b(?:end|take)\s+my\s+(?:own\s+)?life\b/i,
  /\bi\s+(?:want|plan|intend|am going|(?:'m|am)\s+going)\s+to\s+die\b/i,
  /\bi(?:'m| am)\s+suicidal\b/i,
  /\bi(?:'m| am)\s+in\s+(?:immediate\s+)?danger\b/i,
  /\b(?:someone|he|she|they)\s+(?:is|are)\s+(?:going\s+to\s+)?(?:kill|hurt|harm)\s+me\b/i,
  /\bi\s+(?:want|plan|intend|am going|(?:'m|am)\s+going)\s+to\s+(?:kill|hurt|harm)\s+(?:someone|them|him|her)\b/i,
  /\b(?:i\s*(?:am|'m)\s+)?being\s+abused\b/i,
  /\bnot\s+safe\s+(?:at\s+home|here)\b/i,
];

/**
 * Whether the person's words contain a direct urgent-support signal.
 * @param {unknown} text
 * @returns {boolean}
 */
export function needsUrgentSupport(text) {
  if (typeof text !== 'string') return false;
  const words = text.trim();
  if (!words) return false;
  return URGENT_PATTERNS.some((pattern) => pattern.test(words));
}

export default needsUrgentSupport;
